import { defineNuxtPlugin } from "#app"
import ManagerFormDialog from "~/components/Store/ManagerFormDialog.vue"

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.component("ManagerFormDialog", ManagerFormDialog)
})
